module.exports = __webpack_public_path__ + "static/vendor/line-awesome/fonts/line-awesome.ttf";